import React, { Component } from 'react';

import { UPLOAD_DIRECTORY } from '../../../../../../../constants/Define';
import { checkUndefine } from '../../../../../../../helpers/functions';

import {
    FormWrapperInputComponent,
} from "../../../../../common/component/Index";
import Wrapper from '../../../../../common/component/Wrapper';
import RichTextEditor, { ClassicEditor } from '../../../../../common/component/RichTextEditor';
import Collapse, { Panel } from '../../../../../common/component/Collapse';

import TextArea from '../../../../../common/component/TextArea';
import Ripple from '../../../../../common/component/Ripple';
import Input from '../../../../../common/component/Input';
import Modal from '../../../../../common/component/Modal';

import ChecklistItem from './ChecklistItem';

import { TourChecklist } from '../../../../../../../models/Tour';

import { Divider, Icon } from 'antd';

import $ from 'jquery';

import './Note.less';
export default class Note extends Component {
    constructor(props) {
        super(props);
        this.state = {
            collapseState: []
        };
    }

    render() {
        const { t, tour, validation } = this.props;
        return (
            <Wrapper className="tour-detail-note row">
                <Wrapper className="col-md-12">
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.serviceIncluded`)}
                    >
                        <TextArea
                            className="form-control" name="serviceIncluded" onChange={this.onTextAreaChange('serviceIncluded')}
                            value={this.getTextAreaValue(tour.serviceIncluded)} />
                    </FormWrapperInputComponent>
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.serviceExcluded`)}
                    >
                        <TextArea
                            className="form-control" name="serviceExcluded" onChange={this.onTextAreaChange('serviceExcluded')}
                            value={this.getTextAreaValue(tour.serviceExcluded)} />
                    </FormWrapperInputComponent>
                    <FormWrapperInputComponent
                        typeInput={true}
                        isRequired={'right'}
                        isValidation={true}
                        dataValidation={tour.cancellationPolicy}
                        validation={validation.cancellationPolicy}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.cancellationPolicy`)}
                    >
                        <RichTextEditor
                            editor={ClassicEditor}
                            data={tour.cancellationPolicy || ""}
                            config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.props.onChange("cancellationPolicy", data)
                            }}
                        />
                    </FormWrapperInputComponent>
                    <FormWrapperInputComponent
                        typeInput={true}
                        // isRequired={'right'}
                        // isValidation={true}
                        // dataValidation={tour.operationManuals}
                        // validation={validation.operationManuals}
                        messageBelowInput={true}
                        labelTitle={t(`item.tour.operationManuals`)}
                    >
                        <RichTextEditor
                            editor={ClassicEditor}
                            data={tour.operationManuals || ""}
                            config={{ uploadDirectory: UPLOAD_DIRECTORY.TOUR_THUMB }}
                            onChange={(event, editor) => {
                                const data = editor.getData();
                                this.props.onChange("operationManuals", data)
                            }}
                        />
                    </FormWrapperInputComponent>
                    {/* <Divider className={'mb-0'} />
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.checklist`)}
                        classInputForm={`col-md-9 ${tour.checklist && !!tour.checklist.length ? 'pb-0' : 'p-0'}`}
                        className="mb-0"
                    >
                        {this.renderChecklists()}
                    </FormWrapperInputComponent>
                    <Divider className={'mt-0'} /> */}
                    <FormWrapperInputComponent
                        typeInput={true}
                        labelTitle={t(`item.tour.note`)}
                    >
                        <TextArea
                            className="form-control" name="note" onChange={this.onTextAreaChange('note')}
                            value={this.getTextAreaValue(tour.note)} />
                    </FormWrapperInputComponent>
                </Wrapper>

            </Wrapper>
        )
    }

    renderChecklists() {
        const { t, tour } = this.props;
        const renderPannel = (checklist, index) => (
            <Panel
                header={this.state.collapseState.includes(String(index)) ?
                    <Input placeholder={t(`item.tour.tourTitle`)} type={`text`}
                        className={`form-control`}
                        name={`checklistTitle${index}`} onClick={e => e.stopPropagation()} onChange={e => this.onChangeChecklistTitle(index, e.target.value)}
                        value={checkUndefine(checklist.title)} />
                    : (checklist.title || t(`item.tour.checkListEmptyTitle`))
                }
                key={String(index)}
                extra={<Icon type="delete" className="mr-2 btn-delete" onClick={(e) => this.onRemoveChecklist(index, e)} />}
            >
                <TextArea placeholder={t(`item.tour.checklistContent`)}
                    className="form-control ml-4" name={`checklistContent${index}`} onChange={e => this.onChangeChecklistContent(index, e.target.value)}
                    value={this.getTextAreaValue(checklist.content)} />
            </Panel>
        );
        return (
            <Wrapper className="tour-detail-note-checklist">
                <Collapse bordered={false} defaultActiveKey={this.getEmptyChecklists()}
                    activeKey={this.state.collapseState}
                    destroyInactivePanel={true}
                    onChange={this.onChecklistItemCollapse}>
                    {(tour.checklist || []).map(renderPannel)}
                </Collapse>
                <Ripple className="btn btn-add-checklist" onClick={this.onAddNewChecklist}>
                    <Icon type="plus" className="mr-2" />{`${t('action.add')} ${t('item.tour.checklist').toLowerCase()}`}
                </Ripple>
            </Wrapper>
        )
    }

    onTextAreaChange = (fieldName) => e => {
        const valueArray = (e.target.value || '').split('\n');
        return this.props.onChange(fieldName, valueArray)
    }

    getTextAreaValue = (values = []) => {
        return checkUndefine(values.join('\n'));
    }

    onChangeChecklistTitle = (index, value) => {
        const tour = this.props.tour;
        const checklist = (tour.checklist || [])
        if (checklist[index]) {
            checklist[index].title = value;
        }
        this.props.onChange('checklist', checklist);
    }

    onChangeChecklistContent = (index, value) => {
        const tour = this.props.tour;
        const checklist = (tour.checklist || [])
        if (checklist[index]) {
            const valueArray = (value || '').split('\n');
            checklist[index].content = valueArray;
        }
        this.props.onChange('checklist', checklist);
    }

    onAddNewChecklist = () => {
        const tour = this.props.tour;
        const checklist = (tour.checklist || []).concat([new TourChecklist()]);
        this.props.onChange('checklist', checklist);
        let clickTimeout = setTimeout(() => {
            $('.tour-detail-note-checklist .ant-collapse-item:last-child .ant-collapse-header[aria-expanded="false"]').click();
            $('.tour-detail-note-checklist .ant-collapse-item:last-child .ant-collapse-header input').focus();
            clearTimeout(clickTimeout);
        }, 100);
    }

    onRemoveChecklist = (index, e) => {
        const { t, tour } = this.props;
        if (e) {
            e.stopPropagation();
        }
        const { confirm } = Modal;
        const removeCheckList = () => {
            let checklist = (tour.checklist || []);
            if (index >= 0) checklist.splice(index, 1)
            this.props.onChange('checklist', checklist);
            const collapseState = this.state.collapseState.map(item => {
                if (Number(item) >= index) {
                    return Number(item) - 1 >= 0 && String(Number(item) - 1)
                } else {
                    return item
                }
            }).filter(i => !!i);
            this.setState({ collapseState });
        }
        confirm({
            title: t(`notification.sureRemove`),
            okText: t(`action.remove`),
            cancelText: t(`action.cancel`),
            onOk: removeCheckList,
        });
    }

    getEmptyChecklists() {
        const tour = this.props.tour;
        const checklist = (tour.checklist || [])
        let result = [];
        checklist.forEach((item, index) => {
            if (!item.title) {
                result.push(String(index))
            }
        });
        return result;
    }

    onChecklistItemCollapse = (keys) => {
        this.setState({ collapseState: keys })
    }

}

Note.defaultProps = {
    onChange: (fieldName, value) => { },
}

